<template>
    <div class="lines" ref="linesMaster">
        <!-- Other line types remain unchanged -->
        <div v-if="type==='blank'" class="blank-line">
            <div class="line "></div>
        </div>
        <div v-if="type==='top'" class="top-line">
            <div class="txt-outer ">
                <router-link v-if="link" class="txta" :to="link" :aria-label="label">
                    <span class="txta2">{{ label }}</span>
                    <CaretRight class="caret-icon"/>
                </router-link>
                <span v-else class="txt" v-html="getLabel(label)"></span>
            </div>
            <div class="line "></div>
        </div>
        <div v-if="type==='bottom'" class="bottom-line">
            <div class="txt-outer ">
                <router-link v-if="link" class="txta" :to="link" :aria-label="label">
                    <span class="txta2">{{ label }}</span>
                    <CaretRight class="caret-icon"/>
                </router-link>
                <span v-else class="txt" v-html="getLabel(label)"></span>
            </div>
            <div class="line "></div>
        </div>
        <div v-if="type==='center'" class="center-line">
            <div class="line linel "></div>
            <div class="txt-outer ">
                <router-link v-if="link" class="txta" :to="link" :aria-label="label">
                    <span class="txta2">{{ label }}</span>
                    <CaretRight class="caret-icon"/>
                </router-link>
                <span v-else class="txt" v-html="getLabel(label)"></span>
            </div>
            <div class="line liner "></div>
        </div>
        <div v-if="type==='releases-down' || type==='releases-up'" :id="`lr-line-${type}`" class="lr-line">
            <div class="txt-outer txt-outer1 ">
                <span class="txt" v-html="getLabel(label)"></span>
            </div>
            <div class="line "></div>
            <div class="txt-outer txt-outer2 ">
                <span v-if="type==='releases-down'" class="txta" @click="scrollTo('#lr-line-releases-up')">
                    <span class="txta2">
                        {{label2}} <ArrowDown class="arrow-icon"/>
                    </span>
                </span>
                <span v-if="type==='releases-up'" class="txta" @click="scrollTo('#lr-line-releases-down')">
                    <span class="txta2">
                        {{label2}} <ArrowUp class="arrow-icon"/>
                    </span>
                </span>
            </div>
        </div>
        <div v-if="type==='allnews'" class="allnews">
            <div class="txt-outer ">
                <router-link v-if="link" class="txta" :to="link" :aria-label="label">
                    <span class="txta2">{{ label }}</span>
                    <CaretRight class="caret-icon"/>
                </router-link>
                <span v-else class="txt" v-html="getLabel(label)"></span>
            </div>
            <div class="line "></div>
            <div class="right-boxes ">
                <div class="search-outer">
                    <div class="search">
                        <!-- Bind the search input value and call doSearch on Enter -->
                        <input
                            class="search-field"
                            v-model="searchTerm"
                            @keyup.enter="doSearch"
                            placeholder="SEARCH"
                            maxlength="35"
                        />
                        <!-- Show clear button only if there are search results -->
                        <div
                            v-if="searchResults.length > 0"
                            @click="clearSearch"
                            class="close-button small">
                        </div>
                        <SearchIcon class="icon-search" @click="doSearch"/>
                    </div>
                </div>
                <div class="filter-outer">
                    <div class="filter" @click="openFilterSidebar">
                        <div class="txt">Filter</div>
                        <!-- Show clear button only if there are selected filters; stop propagation so the filter doesn't open -->
                        <div
                            v-if="selectedFilters.length > 0"
                            @click.stop="clearFilter"
                            class="close-button small">
                        </div>
                        <FilterIcon class="icon-filter"/>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import gsap from '@/plugins/gsap';
import ScrollToPlugin from "@/plugins/gsap/ScrollToPlugin";
import ArrowDown from "@/components/svgs/ArrowDown.vue";
import ArrowUp from "@/components/svgs/ArrowUp.vue";
import CaretRight from "@/components/svgs/CaretRight.vue";
import FilterIcon from "@/components/svgs/FilterIcon.vue";
import SearchIcon from "@/components/svgs/SearchIcon.vue";
gsap.registerPlugin(ScrollToPlugin);

export default {
    name: "LinesComponent",
    components: {SearchIcon, FilterIcon, CaretRight, ArrowUp, ArrowDown },
    props: {
        type: { type: String, required: true },
        label: { type: String, required: false, default: null },
        link: { type: String, required: false, default: null },
        label2: { type: String, required: false, default: null  },
    },
    data() {
        return {
            searchTerm: "",
            observer: null,
        };
    },
    computed: {
        searchResults() {
            return this.$store.state.searchResults || [];
        },
        selectedFilters() {
            return this.$store.state.selectedFilters || [];
        }
    },
    mounted() {
        gsap.set(this.$refs.linesMaster, { opacity: 0 });
        this.observer = new IntersectionObserver(this.animateOnScroll, {
            root: null,
            rootMargin: '0px 0px -150px 0px',
            threshold: 0
        });
        this.observer.observe(this.$el);
    },
    methods: {
        animateOnScroll(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    this.startAnimation();
                    this.observer.disconnect();
                }
            });
        },
        startAnimation() {
            const lines = Array.from(this.$el.querySelectorAll('.line'));
            let timeline = gsap.timeline({ defaults: { duration: 0.8, ease: "power2.out" } });
            if (this.type === 'blank') {
                timeline.fromTo(lines, { opacity: 1, scaleX: 0, transformOrigin: 'center' }, { opacity: 1, scaleX: 1 });
            } else if (this.type === 'center') {
                const ttxt = Array.from(this.$el.querySelectorAll('.txt-outer'));
                const linesl = Array.from(this.$el.querySelectorAll('.linel'));
                const linesr = Array.from(this.$el.querySelectorAll('.liner'));
                timeline.fromTo(ttxt, { opacity: 0, y: 0 }, { opacity: 1, y: 0 }, 0);
                timeline.fromTo(linesl, { scaleX: 0, opacity: 1, transformOrigin: 'right' }, { opacity: 1, scaleX: 1 }, 0.2);
                timeline.fromTo(linesr, { scaleX: 0, opacity: 1, transformOrigin: 'left' }, { opacity: 1, scaleX: 1 }, 0.2);
            } else if (this.type === 'top' ) {
                const ttxt = Array.from(this.$el.querySelectorAll('.txt-outer'));
                timeline.fromTo(ttxt, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0);
                timeline.fromTo(lines, { opacity: 1, scaleX: 0, transformOrigin: 'left' }, { opacity: 1, scaleX: 1 }, 0.2);
            } else if (this.type === 'bottom') {
                const ttxt = Array.from(this.$el.querySelectorAll('.txt-outer'));
                timeline.fromTo(ttxt, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0);
                timeline.fromTo(lines, { opacity: 1, scaleX: 0, transformOrigin: 'right' }, { opacity: 1, scaleX: 1 }, 0.2);
            } else if (this.type==='releases-down' || this.type==='releases-up') {
                const ttxt1 = Array.from(this.$el.querySelectorAll('.txt-outer1'));
                const ttxt2 = Array.from(this.$el.querySelectorAll('.txt-outer2'));
                timeline.fromTo(ttxt1, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0);
                timeline.fromTo(lines, { opacity: 1, scaleX: 0, transformOrigin: 'left' }, { opacity: 1, scaleX: 1 }, 0.2);
                timeline.fromTo(ttxt2, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0.4);
            } else if (this.type==='allnews') {
                const ttxt1 = Array.from(this.$el.querySelectorAll('.txt-outer'));
                const ttxt2 = Array.from(this.$el.querySelectorAll('.right-boxes .search-outer'));
                const ttxt3 = Array.from(this.$el.querySelectorAll('.right-boxes .filter-outer'));
                timeline.fromTo(ttxt1, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0);
                timeline.fromTo(lines, { opacity: 1, scaleX: 0, transformOrigin: 'left' }, { opacity: 1, scaleX: 1 }, 0.2);
                timeline.fromTo(ttxt2, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0.4);
                timeline.fromTo(ttxt3, { opacity: 0, x: 0 }, { opacity: 1, x: 0 }, 0.6);
            }
            gsap.set(this.$refs.linesMaster, { opacity: 1 });
        },

        getLabel(lbl) {
            return lbl
        },
        scrollTo(selector) {
            gsap.to(window, { duration: 1, scrollTo: { y: selector, offsetY: 80 } });
        },
        openFilterSidebar() {
            this.$store.commit('openFilter');
        },
        doSearch() {
            this.$store.commit("setSearchTerm", this.searchTerm);
            if (!this.searchTerm.trim()) {
                this.$store.commit("setSearchResults", []);
                return;
            }
            // Set search loading flag to true
            this.$store.commit("setSearchLoading", true);
            this.$store.commit("setSelectedFilters", []);
            const apiBase = process.env.VUE_APP_API_ACTIONS;
            const url = `${apiBase}search?q=${encodeURIComponent(this.searchTerm)}`;
            fetch(url)
                .then(response => response.json())
                .then(data => {
                    this.$store.commit("setSearchResults", data.allNews);
                    this.$store.commit("setSearchLoading", false);
                    this.$store.commit("setSearchError", false);
                })
                .catch(err => {
                    console.error("Search error: ", err);
                    this.$store.commit("setSearchResults", []);
                    this.$store.commit("setSearchLoading", false);
                    this.$store.commit("setSearchError", true);
                });
        },
        clearSearch() {
            this.searchTerm = "";
            this.$store.commit("setSearchResults", null);
            this.$store.commit("setSelectedFilters", []);
            this.$store.commit("setSearchError", false);
        },
        clearFilter() {
            this.$store.commit("setSelectedFilters", []);
            this.$store.commit('closeFilter');
        }
    }
}
</script>

<style scoped>
.line {
    transform: scaleX(0);
    opacity: 1 !important;
}
</style>
